import * as React from 'react';
/**
 *
 * Original name: key
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=24507%3A2805
 *
 */
export const KeyLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 12c0-1.041.253-1.524.49-1.76.236-.237.719-.49 1.76-.49s1.524.253 1.76.49c.237.236.49.719.49 1.76s-.253 1.524-.49 1.76c-.236.237-.719.49-1.76.49s-1.524-.253-1.76-.49c-.237-.236-.49-.719-.49-1.76ZM4 12c0-2.523 1.227-3.75 3.75-3.75 2.26 0 3.48.984 3.71 3.001H20v4.499h-1.5v-2.999H17v2.999h-1.5v-2.999h-4.04c-.232 2.016-1.451 2.999-3.71 2.999C5.227 15.75 4 14.524 4 12Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
